import React from "react";

const PermissionsSelector = ({ routes = [], selected = [], onChange }) => {
  const allSelected =
    routes.length > 0 && routes.every((r) => selected.includes(r.path));

  const toggleRoute = (path) => {
    const newSelected = selected.includes(path)
      ? selected.filter((p) => p !== path)
      : [...selected, path];
    onChange(newSelected);
  };

  const toggleAll = () => {
    if (allSelected) {
      onChange([]);
    } else {
      onChange(routes.map((r) => r.path));
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={toggleAll}
        className="mb-2 rounded bg-gray-200 px-3 py-1 text-sm dark:bg-gray-700"
      >
        {allSelected ? "إلغاء تحديد الكل" : "تحديد الكل"}
      </button>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {routes.map((route) => (
          <label key={route.path} className="flex items-center gap-2">
            <input
              type="checkbox"
              className="accent-blue-500"
              checked={selected.includes(route.path)}
              onChange={() => toggleRoute(route.path)}
            />
            <span>{route.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default PermissionsSelector;
